import https from "https";
var NodeTransport = (function () {
    function NodeTransport(url) {
        this.url = url;
    }
    NodeTransport.prototype.send = function (data) {
        var _this = this;
        var options = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Content-Length": data.length
            }
        };
        return new Promise(function (resolve, reject) {
            var req = https
                .request(_this.url, options, function () { })
                .on("error", function (error) { return reject(error); });
            req.write(data);
            req.end();
            resolve({});
        });
    };
    return NodeTransport;
}());
export { NodeTransport };
//# sourceMappingURL=node.js.map